import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types';
import { assertDefined } from '../../../utils/assertDefined';
import { createApiClient } from '../../apiClient';
import { generateNonceSignature } from '../generateNonceSignature';
import { generateSessionSignature } from '../generateSessionSignature';

export const getSignedSessionId = async (client: DynamicClient) => {
  const core = getCore(client);

  const sessionId = core.state.get().user?.sessionId;
  assertDefined(sessionId, 'Session ID is required');

  const { signature: signedSessionId } = await generateSessionSignature(
    {
      sessionId,
    },
    client
  );

  assertDefined(signedSessionId, 'Signed session ID is required');

  const apiClient = createApiClient({}, client);
  const { nonce } = await apiClient.getNonce({
    environmentId: core.environmentId,
  });

  assertDefined(nonce, 'Nonce is required');

  const { signature: nonceSignature } = await generateNonceSignature(
    {
      nonce,
    },
    client
  );

  assertDefined(nonceSignature, 'Nonce signature is required');

  const signature = `${signedSessionId}/${nonceSignature}/${nonce}`;

  return { signature };
};
